import React from 'react';

interface XlsExtProps {
    width?: number;
    height?: number;
}

export const XlsExt = ({ height = 26, width = 26 }: XlsExtProps) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width}
        height={height}
        viewBox="0 0 26 26"
        fill="none"
    >
        <g clipPath="url(#clip0_5885_18253)">
            <path
                d="M23.3269 5.11064L18.4519 0.235638C18.376 0.160337 18.2859 0.100762 18.1869 0.0603282C18.0879 0.0198946 17.9819 -0.000601989 17.875 1.34596e-05H4.875C3.52879 1.34596e-05 2.4375 1.0913 2.4375 2.43751V23.5625C2.4375 24.9087 3.52879 26 4.875 26H21.125C22.4712 26 23.5625 24.9087 23.5625 23.5625V5.68751C23.5631 5.58058 23.5426 5.47458 23.5022 5.37559C23.4618 5.27659 23.4022 5.18656 23.3269 5.11064ZM21.9375 23.5625C21.9375 24.0113 21.5738 24.375 21.125 24.375H4.875C4.42625 24.375 4.0625 24.0113 4.0625 23.5625V2.43751C4.0625 1.98876 4.42625 1.62501 4.875 1.62501H17.0625V4.87501C17.0625 5.77247 17.79 6.50001 18.6875 6.50001H21.9375V23.5625Z"
                fill="#D7D7D7"
            />
            <path
                d="M20 21.1667C20 21.625 19.625 22 19.1667 22H0.833333C0.375 22 0 21.625 0 21.1667V12.8333C0 12.375 0.375 12 0.833333 12H19.1667C19.625 12 20 12.375 20 12.8333V21.1667Z"
                fill="#84BD5A"
            />
            <path
                d="M15.7997 18.2085C15.7997 18.5047 15.7268 18.7599 15.5809 18.9741C15.4374 19.1883 15.23 19.3524 14.9589 19.4663C14.69 19.5802 14.3687 19.6372 13.995 19.6372C13.8127 19.6372 13.6384 19.627 13.472 19.6064C13.3057 19.5859 13.1485 19.5563 13.0004 19.5176C12.8545 19.4766 12.7212 19.4276 12.6005 19.3706V18.5981C12.8033 18.687 13.03 18.7679 13.2806 18.8408C13.5313 18.9115 13.7865 18.9468 14.0463 18.9468C14.2582 18.9468 14.4336 18.9194 14.5726 18.8647C14.7139 18.8078 14.8187 18.728 14.8871 18.6255C14.9554 18.5207 14.9896 18.3988 14.9896 18.2598C14.9896 18.1117 14.9497 17.9863 14.87 17.8838C14.7902 17.7812 14.6695 17.6878 14.5077 17.6035C14.3482 17.5169 14.1477 17.4246 13.9061 17.3267C13.7421 17.2606 13.5848 17.1854 13.4344 17.1011C13.2863 17.0168 13.1542 16.9176 13.038 16.8037C12.9218 16.6898 12.8295 16.5553 12.7611 16.4004C12.695 16.2432 12.662 16.0586 12.662 15.8467C12.662 15.5641 12.7292 15.3226 12.8636 15.1221C13.0004 14.9215 13.1918 14.7677 13.4379 14.6606C13.6862 14.5535 13.9756 14.5 14.306 14.5C14.5681 14.5 14.8142 14.5273 15.0443 14.582C15.2767 14.6367 15.5046 14.7142 15.7279 14.8145L15.4681 15.4741C15.2631 15.3898 15.0637 15.3226 14.87 15.2725C14.6786 15.2223 14.4826 15.1973 14.2821 15.1973C14.1089 15.1973 13.962 15.2235 13.8412 15.2759C13.7204 15.3283 13.6281 15.4023 13.5643 15.498C13.5028 15.5915 13.472 15.7031 13.472 15.833C13.472 15.9788 13.5074 16.1019 13.578 16.2021C13.6509 16.3001 13.7626 16.3901 13.913 16.4722C14.0656 16.5542 14.2616 16.6453 14.5009 16.7456C14.7766 16.8595 15.0101 16.9792 15.2015 17.1045C15.3952 17.2298 15.5433 17.3802 15.6459 17.5557C15.7484 17.7288 15.7997 17.9465 15.7997 18.2085Z"
                fill="white"
            />
            <path
                d="M9.30713 19.5688V14.5718H10.1274V18.8716H12.25V19.5688H9.30713Z"
                fill="white"
            />
            <path
                d="M8.83398 19.5688H7.90088L6.64307 17.5215L5.37842 19.5688H4.5L6.16113 16.978L4.61279 14.5718H5.51855L6.68066 16.4653L7.83594 14.5718H8.71436L7.15918 17.002L8.83398 19.5688Z"
                fill="white"
            />
        </g>
        <defs>
            <clipPath id="clip0_5885_18253">
                <rect width="26" height="26" fill="white" />
            </clipPath>
        </defs>
    </svg>
);
